import { render } from "./V-Footer.vue?vue&type=template&id=3770ffe6&scoped=true"
import script from "./V-Footer.vue?vue&type=script&lang=js"
export * from "./V-Footer.vue?vue&type=script&lang=js"

import "./V-Footer.vue?vue&type=style&index=0&id=3770ffe6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3770ffe6"]])

export default __exports__